/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import '../../../app/globals.css';
import './DefaultLayoutCN.css';

import FooterCN from '../FooterCN';
import HeaderCN from '../HeaderCN';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutCN = async ({ children }: LayoutProps) => {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-cn">
        <link rel="shortcut icon" href="/jc/favicon.ico" />
        <div className="h-full flex flex-col justify-between">
          <div>
            <HeaderCN skipSession />
            <main>{children}</main>
          </div>
          <FooterCN isAuthorized={false} />
        </div>
      </body>
    </html>
  );
};

export default DefaultLayoutCN;
